<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedEmployees()" [disabled]="!selectedEmployees || !selectedEmployees.length "></button>
        </div> 
    </div>

    <div class="page-content">
        <p-table #dt 
            [value]="employees" 
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['firstName', 'lastName', 'jobFunction', 'email', 'phoneNumber']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedEmployees" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>


            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <!-- <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th> -->
                    <!-- <th id="employeeId" name="employeeId" pResizableColumn pReorderableColumn pSortableColumn="employeeId"[class]="includesCol('employeeId') ? 'd' : 'h'">Id 
                        <p-sortIcon field="employeeId"></p-sortIcon> 
                        <p-columnFilter type="text" field="id" display="menu"></p-columnFilter>
                    </th> -->

                    <th id="firstName" name="firstName" pResizableColumn pReorderableColumn pSortableColumn="firstName" [class]="includesCol('firstName') ? 'd' : 'h'">First name 
                        <p-sortIcon field="firstName"></p-sortIcon> 
                        <p-columnFilter type="text" field="firstName" display="menu"></p-columnFilter>
                    </th>
                    <th id="lastName" name="lastName" pResizableColumn pReorderableColumn pSortableColumn="lastName" [class]="includesCol('lastName') ? 'd' : 'h'">Last name 
                        <p-sortIcon field="lastName"></p-sortIcon> 
                        <p-columnFilter type="text" field="lastName" display="menu"></p-columnFilter>
                    </th>
                    <th id="jobFunction" name="jobFunction" pResizableColumn pReorderableColumn pSortableColumn="jobFunction" [class]="includesCol('jobFunction') ? 'd' : 'h'">Function 
                        <p-sortIcon field="jobFunction"></p-sortIcon> 
                        <p-columnFilter type="text" field="jobFunction" display="menu"></p-columnFilter>
                    </th>
                    <th id="email" name="email" pResizableColumn pReorderableColumn pSortableColumn="email" [class]="includesCol('email') ? 'd' : 'h'">Email 
                        <p-sortIcon field="email"></p-sortIcon> 
                        <p-columnFilter type="text" field="email" display="menu"></p-columnFilter>
                    </th>
                    <th id="phoneNumber" name="phoneNumber" pResizableColumn pReorderableColumn pSortableColumn="phoneNumber" [class]="includesCol('phoneNumber') ? 'd' : 'h'">Phone Number 
                        <p-sortIcon field="phoneNumber"></p-sortIcon> 
                        <p-columnFilter type="text" field="phoneNumber" display="menu"></p-columnFilter>
                    </th>
                    <th id="randomPassword" name="randomPassword" pResizableColumn pReorderableColumn pSortableColumn="randomPassword" [class]="includesCol('randomPassword') ? 'd' : 'h'">Random Password 
                        <p-sortIcon field="randomPassword"></p-sortIcon> 
                        <p-columnFilter type="text" field="randomPassword" display="menu"></p-columnFilter>
                    </th>

                    <!-- <th id="notes" name="notes" pResizableColumn pReorderableColumn [class]="includesCol('notes') ? 'd' : 'h'">Notes</th> -->
                    <!-- <th pSortableColumn="price">Price <p-sortIcon field="price"></p-sortIcon></th>
                    <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th>
                    <th pSortableColumn="rating">Reviews <p-sortIcon field="rating"></p-sortIcon></th>
                    <th pSortableColumn="inventoryStatus">Status <p-sortIcon field="inventoryStatus"></p-sortIcon></th> -->
                    <th pResizableColumn pReorderableColumn style="width: 8rem">Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-employee let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" [pSelectableRow]="employee">

                    <td pEditableColumn [class]="includesCol('firstName') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="employee.firstName" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{employee.firstName}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('lastName') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="employee.lastName" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{employee.lastName}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('jobFunction') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="employee.jobFunction" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{employee.jobFunction}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                
                    <td pEditableColumn [class]="includesCol('email') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="employee.email"  (blur)="completeEmployee(employee)" (keydown.tab)="completeEmployee(employee)" (keydown.enter)="completeEmployee(employee)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{employee.email}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('phoneNumber') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="employee.phoneNumber"  (blur)="completeEmployee(employee)" (keydown.tab)="completeEmployee(employee)" (keydown.enter)="completeEmployee(employee)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{employee.phoneNumber}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('randomPassword') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="employee.randomPassword" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{employee.randomPassword}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    
                    <td class="row-actions">
                        <button pButton style="margin-right: 10px"  pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editEmployee(employee)"></button>
                        <button pButton style="margin-right: 10px"  pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteEmployee(employee)"></button>
                        <p-tableCheckbox class="checkbox" [value]="employee"></p-tableCheckbox>
                    </td>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{employees ? employees.length : 0 }} employees.
                    </div>
                    <div class="summary-export">
                        <button type="button" style="margin-right: 10px" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button>
                        <button type="button" style="margin-right: 10px" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
       
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>
            
    </div>
    
    <p-dialog [(visible)]="employeeDialog" [style]="{width: '450px', height: '450px'}" header="Employee Details" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        <!-- <ng-template > -->
            <!-- <img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.image" class="product-image" *ngIf="product.image"> -->
            <!-- <div class="p-field" style="margin-top: 10px;">
                <label for="name">Employee ID</label>
                <input style="margin-top: 10px;" type="text" pInputText id="name" [(ngModel)]="employee.employeeId" required autofocus />
            </div> -->

            <div class="p-field" style="margin-top: 10px;">
                <label for="firstName">First Name</label>
                <input style="margin-top: 10px;" type="text" pInputText id="firstName" [(ngModel)]="employee.firstName" required autofocus />
                <!-- <small class="p-error" *ngIf="submitted && !employee.firstName">First name is required.</small> -->
            </div>

            <div class="p-field" style="margin-top: 10px;">
                <label for="lastName">Last Name</label>
                <input style="margin-top: 10px;" type="text" pInputText id="lastName" [(ngModel)]="employee.lastName" required autofocus />
                <!-- <small class="p-error" *ngIf="submitted && !employee.lastName">Last name is required.</small> -->
            </div>

            <div class="p-field" style="margin-top: 10px;">
                <label for="jobFunction">Job Function</label>
                <input style="margin-top: 10px;" type="text" pInputText id="jobFunction" [(ngModel)]="employee.jobFunction" required autofocus />
                <!-- <small class="p-error" *ngIf="submitted && !employee.jobFunction">Job Function is required.</small> -->
            </div>

            <div class="p-field" style="margin-top: 10px;">
                <label for="email">Email</label>
                <input style="margin-top: 10px;" type="text" pInputText id="email" [(ngModel)]="employee.email" required autofocus />
                <small class="p-error" *ngIf="submitted && !employee.email">Email is required.</small>
            </div>

            <div class="p-field" style="margin-top: 10px;">
                <label for="phoneNumber">Phone number</label>
                <input style="margin-top: 10px;" type="text" pInputText id="phoneNumber" [(ngModel)]="employee.phoneNumber" required autofocus />
            
            </div>

            <div class="p-field" style="margin-top: 10px;">
                <label for="randomPassword">Random password</label>
                <input style="margin-top: 10px;" type="text" pInputText id="randomPassword" [(ngModel)]="employee.randomPassword" required autofocus />
            </div>

            <!-- <div class="p-field">
                <label for="inventoryStatus">Inventory Status</label> -->
                <!-- <p-dropdown [(ngModel)]="product.inventoryStatus" inputId="inventoryStatus" [options]="statuses" placeholder="Select">
                    <ng-template let-option pTemplate="item">
                        <span [class]="'product-badge status-' + option.value">{{option.label}}</span>
                    </ng-template>
                </p-dropdown> -->
            <!-- </div> -->
    
            <!-- <div class="p-field">
                <label class="p-mb-3">Category</label>
                <div class="p-formgrid p-grid">
                    <div class="p-field-radiobutton p-col-6">
                        <p-radioButton id="category1" name="category" value="Accessories" [(ngModel)]="product.category"></p-radioButton>
                        <label for="category1">Accessories</label>
                    </div>
                    <div class="p-field-radiobutton p-col-6">
                        <p-radioButton id="category2" name="category" value="Clothing" [(ngModel)]="product.category"></p-radioButton>
                        <label for="category2">Clothing</label>
                    </div>
                    <div class="p-field-radiobutton p-col-6">
                        <p-radioButton id="category3" name="category" value="Electronics" [(ngModel)]="product.category"></p-radioButton>
                        <label for="category3">Electronics</label>
                    </div>
                    <div class="p-field-radiobutton p-col-6">
                        <p-radioButton id="category4" name="category" value="Fitness" [(ngModel)]="product.category"></p-radioButton>
                        <label for="category4">Fitness</label>
                    </div>
                </div>
            </div> -->
    
            <!-- <div class="p-formgrid p-grid"> -->
                <!-- <div class="p-field p-col"> -->
                    <!-- <label for="price">Price</label> -->
                    <!-- <p-inputNumber id="price" [(ngModel)]="product.price" mode="currency" currency="USD" locale="en-US"></p-inputNumber> -->
                <!-- </div>
                <div class="p-field p-col">
                    <label for="quantity">Quantity</label> -->
                    <!-- <p-inputNumber id="quantity" [(ngModel)]="product.quantity"></p-inputNumber> -->
                <!-- </div>
            </div> -->
        <!-- </ng-template> -->

        <!-- https://dev.to/idrisrampurawala/exporting-data-to-excel-and-csv-in-angular-3643 -->
        
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveEmployee()"></button>
        </div>
    </p-dialog>
    
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

</div>




